// 28-04-2025
import { formatBase64, formatBase64ToBlob } from "../../pages/Utility/utilsFunctions";
import { getImage } from "../imageAPI";
import localforage from "localforage";
/**
 * Makes a call to get the Image
 * @param {string} id - to get the Image valid "id"
 * @returns - returns Image data
 */
//  const handleGetImage = async (id) => {
//     try {
//       const response = await getImage(id);
//       const { message, data } = response;
//       if (!data) return null;
//       const imageSrc = formatBase64(data);
//       return imageSrc;
//     } catch (err) {
//         console.log("Error to fetch the image: ", err.msg)
//     }
//   };

const handleGetImage = async (id) => {
  try {
    const response = await getImage(id);
    const { data } = response;
    if (!data) return null;
    const imageBlob = formatBase64ToBlob(data);
    return imageBlob;
  } catch (err) {
    console.log("Error to fetch the image: ", err.message);
    return null;
  }
};

// //  to fetch the image for each of the location/ charger
//   export const loadImages = async (data) => {
//     const images = {};
//     const dataWithImageId = data?.filter((item) => item?.imageId !== undefined );
//     await Promise.all(
//       dataWithImageId.map(async (charger) => {
//         try {
//           if(!charger?.imageId?.startsWith("https://")){
//             const image = await handleGetImage(charger.imageId);
//             images[charger.imageId] = image;
//           }

//         } catch (err) {
//           console.log("Error loading image for ID", charger.imageId, err);
//         }
//       })
//     );
//     return images;
//   };

// export const loadImages = async (data) => {
//   const images = {};
//   const dataWithImageId = data?.filter((item) => item?.imageId !== undefined);

//   await Promise.all(
//     dataWithImageId.map(async (charger) => {
//       const imageId = charger.imageId;

//       // Check if it's already in localStorage
//       const cached = localStorage.getItem(`image_${imageId}`);
//       if (cached) {
//         images[imageId] = cached;
//         console.log("fetched from cache");

//         return;
//       }

//       try {
//         const image = await handleGetImage(imageId);
//         console.log("fetched from the api");

//         if (image) {
//           localStorage.setItem(`image_${imageId}`, image);
//           images[imageId] = image;
//         }
//       } catch (err) {
//         console.log("Error loading image for ID", imageId, err);
//       }
//     })
//   );

//   return images;
// };

export const loadImages = async (data) => {
  const images = {};
  const dataWithImageId = data?.filter((item) => item?.imageId !== undefined);

  await Promise.all(
    dataWithImageId.map(async (charger) => {
      const imageId = charger.imageId;

      try {
        const cachedBlob = await localforage.getItem(`image_${imageId}`);
        // console.log("cachedBlob: ",cachedBlob);
        
        if (cachedBlob) {
          images[imageId] = URL.createObjectURL(cachedBlob); // Create preview
          // console.log("Fetched from IndexedDB cache");
          return;
        }
        if (!charger?.imageId?.startsWith("https://")) {
          const imageBlob = await handleGetImage(charger.imageId);
          if (imageBlob) {
            await localforage.setItem(`image_${imageId}`, imageBlob);
            images[imageId] = URL.createObjectURL(imageBlob);
            // console.log("Fetched from API and cached");
          }
        }

      } catch (err) {
        console.log("Error loading image for ID", imageId, err);
      }
    })
  );

  return images;
};
